export default __webpack_public_path__ + "static/lucrys-cf993e7824116c58bcd30d4f946b2b0f.png";